export const host: string = 'https://ecom-api.kitg.com.ua'
export const hostImage: string = 'https://ecom-images.kitg.com.ua'

export const api = {
	withAPI: `${host}`,
	withImageAPI:`${hostImage}`,
}
